const featureToggles = {
  costEstimate: true,
  branches: false,
  qualityIndicators:
    process.env.REACT_APP_FEATURE_QUALITY_INDICATORS === 'true',
  persistStore: true,
}

export default featureToggles
